import AddIcon from '@mui/icons-material/Add';
import { Alert } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState } from 'react';
import Modal from '../elements/Modal';
import CategoryForm from './CategoryForm';
import useAuthToken from '../../hooks/getUserData';

const AddCategory = ({ fetchData, setMessage, setSnackbarOpen }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const token = useAuthToken();

  const handleSubmit = async (values) => {
    setError(null);
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('description', values.description);
    formData.append('insights', values.insights);
    formData.append('image', values.image);
    formData.append('showMdBadge', values.showMdBadge);
    formData.append('hide', values.hide);
    formData.append('tag', values.tag);
    
    if(values.categoryDetails.length > 0){
      values.categoryDetails.forEach((field, index) => {
        if(field !== ''){
          formData.append(`categoryDetails[]`, field.toLowerCase());
        }
      });
    } 

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/categories`,
        {
          method: 'POST',
          body: formData,
          headers: { Authorization: token },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Category added successfully');
      fetchData();
      handleClose();
    } catch (err) {
      setError('Failed to add a new category. ' + err.message);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(false)
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}>
        New Category
      </Button>
      <Modal
        open={open}
        modalTitle="Add Category"
        handleClose={handleClose}
        width="sm">
        {error && <Alert severity="error">{error}</Alert>}
        <CategoryForm onSubmit={handleSubmit} />
      </Modal>
    </>
  );
};

export default AddCategory;
